import { render } from "./DocumentsTableCard.vue?vue&type=template&id=03949f30&scoped=true"
import script from "./DocumentsTableCard.vue?vue&type=script&lang=js"
export * from "./DocumentsTableCard.vue?vue&type=script&lang=js"

import "./DocumentsTableCard.vue?vue&type=style&index=0&id=03949f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03949f30"]])

export default __exports__